import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const editingIntegration = {
  popover: {
    title: 'Editing an Integration',
    description: 'You can manage your integration by updating its settings, parameters, or fallback options.',
    onNextClick: () => {
      const actionsToggle = document.querySelector('#plugins > div.page-content > div > div:nth-child(1) > div.action');

      if (actionsToggle) {
        actionsToggle.classList.add('tour-show');

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};
